import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'wp-user-profile-info-edit',
  templateUrl: './user-profile-info-edit.component.html',
  styleUrls: ['./user-profile-info-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileInfoEditComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
